import React from 'react';
import { useTranslation } from 'utils/i18n';
import { StaticPageShell } from 'feSharedIndex';

// Import extracted logic
import translations from './translations';

/**
 * Partners Component
 * Displays partner information. Uses shared StaticPageShell; theme from config.
 */
const Partners = () => {
  const { language } = useTranslation();

  const t = (key, defaultValue = '') => {
    const pageTranslations = translations[language] || translations.en;
    const value = key.split('.').reduce((obj, k) => obj?.[k], pageTranslations);
    if (value !== undefined && value !== null && value !== '') {
      return value;
    }
    return defaultValue !== '' ? defaultValue : key;
  };

  return (
    <StaticPageShell
      title={t('title', 'Partners')}
      lead={t('subtitle', 'Our technology and solution partners')}
      contentClassName="static-page-content"
    >
      <section className="content-section">
        <h2>{t('description', 'Partner Overview')}</h2>
        <p>
          {t('descriptionText', 'We work with leading technology and solution partners to provide the best solutions for our customers.')}
        </p>
      </section>
    </StaticPageShell>
  );
};

export default Partners;


